// Swiper 8.3.2 — module subset, built through webpack so the unused modules are
// tree-shaken out instead of shipped.
//
// WHY THIS FILE EXISTS
// -------------------
// The theme used to load `swiper-bundle.min.js`: 143,281 B, which was 79% of the
// whole 180,165 B script bundle. A bundle build contains every module Swiper has —
// virtual, keyboard, mousewheel, scrollbar, parallax, zoom, lazy, controller,
// a11y, history, hash-navigation, grid, thumbs, free-mode, manipulation, and the
// six effects (fade, cube, flip, coverflow, creative, cards).
//
// main.js uses three. Every option key passed to `new Swiper()` across all twelve
// constructors was enumerated; the complete set is:
//
//   loop, speed, spaceBetween, slidesPerView, centeredSlides, breakpoints,
//   autoplay{delay, disableOnInteraction}, navigation{nextEl, prevEl},
//   pagination{el, clickable}
//
// There is no `effect:`, `thumbs:`, `scrollbar:`, `zoom:`, `virtual:`, `lazy:`,
// `freeMode:`, `keyboard:` or `mousewheel:` key anywhere in the theme, so nothing
// else has anything to attach to.
//
// WHY A GLOBAL, AND WHY A SEPARATE FILE
// -------------------------------------
// main.js is a plain jQuery IIFE loaded via mix.scripts() (concatenation, not
// webpack), so it cannot `import`. It calls the bare global `Swiper`, which is
// what the bundle build used to provide — so this file reproduces that global and
// main.js is untouched.
//
// It has to be its own request because mix.scripts() only concatenates: it cannot
// resolve the ESM imports below. config.php loads it BEFORE default.js and
// declares it as a dependency of `default-js`, which is what guarantees the
// global exists by the time main.js's document-ready handler runs.
//
// The matching CSS subset is assets/sass/vendor/_swiper-subset.scss. Adding a
// module means editing both files.
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

Swiper.use([Navigation, Pagination, Autoplay])

window.Swiper = Swiper
